/**
 * Created by jonas on 2022-01-11.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {BrickSnake2000} from "../BrickSnake2000";
import {BrickSnake2000Sound} from "../sound/BrickSnake2000Sound";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {FreespinsOutroInformation} from "../components/FreespinsOutroInformation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {BrickSnake2000Symbol} from "../reels/symbols/BrickSnake2000Symbol";

export class BrickSnake2000TransitionScreenView extends PIXI.Container implements StageLayer {
    protected button:ContinueButton;
    protected gambleYesButton:ContinueButton;
    protected gambleNoButton:ContinueButton;
    protected gambleWarningText:PIXI.Text;
    private gambleConfirmationText:PIXI.Text;
    private yesButtonCallback:Function;
    private noButtonCallback:Function;
    private replayClick:TimelineSprite;
    //protected gambleText:PIXI.Text;

    private clickCallback?:Function;
    private fsIntroBackground:PIXI.Sprite;
    private sfsIntroBackground:PIXI.Sprite;
    private maxWinBackground:PIXI.Sprite;
    private maxWinDoubleBackground:PIXI.Sprite;
    private maxWinNothingBackground:PIXI.Sprite;
    private slayerSpine:PIXI.spine.Spine;
    private introSpine:PIXI.spine.Spine;
    private noWinSpine:PIXI.spine.Spine;
    private maxWinSpine:PIXI.spine.Spine;
    private outroInformation:FreespinsOutroInformation;
    private gameIntro:PIXI.spine.Spine;
    private gameIntroTimeline:gsap.core.Timeline;

    constructor(name?:string) {
        super();
        this.name = name ? name : "BrickSnake2000TransitionScreenView";
        const coloredSquare = (color:string) => {
            const square = new PIXI.Sprite(PIXI.Texture.WHITE);
            square.tint = PIXI.utils.string2hex(color);
            square.position.set(360, 360);
            square.anchor.set(0.5, 0.5);
            square.alpha = 0.8;
            square.visible = false;
            return square;
        }
        this.fsIntroBackground = coloredSquare("#0066ff");
        this.sfsIntroBackground = coloredSquare("#ff6600");
        this.maxWinBackground = coloredSquare("#0000cc");
        this.maxWinDoubleBackground = coloredSquare("#ff002f");
        this.maxWinNothingBackground = coloredSquare("#000000");

        const warningTextStyle= new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#ffff00",
            fontFamily: "Helvetica",
            fontSize: 40,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#232323",
            strokeThickness: 8,
            align: "center",
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,
        });
        const warningText = "50/50 chance to double your Max Win, or lose it all.";
        this.gambleWarningText = new PIXI.Text(BrickSnake2000.apiPlugin.translations.translate(warningText), warningTextStyle);
        this.gambleWarningText.anchor.set(0.5,0.5);
        this.gambleWarningText.position.set(360,320);
        this.gambleWarningText.visible = false;

        const confirmationTextStyle = new PIXI.TextStyle({
            dropShadow: true,
            dropShadowAlpha: 0.5,
            dropShadowAngle: 1.5,
            dropShadowDistance: 6,
            fill: "#ee2553",
            fontFamily: "Helvetica",
            fontSize: 80,
            fontWeight: "bolder",
            lineJoin: "round",
            stroke: "#232323",
            strokeThickness: 8,
            align: "center",
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,
        });
        const confirmationText = "Really!?";
        this.gambleConfirmationText = new PIXI.Text(BrickSnake2000.apiPlugin.translations.translate(confirmationText), confirmationTextStyle);
        this.gambleConfirmationText.anchor.set(0.5,0.5);
        this.gambleConfirmationText.position.set(360,320);
        this.gambleConfirmationText.visible = false;


        //const gambleText = "DOUBLE OR NOTHING";
        //this.gambleText = new PIXI.Text(BrickSnake2000.apiPlugin.translations.translate(gambleText), warningTextStyle);
        //this.gambleText.anchor.set(0.5,0.5);
        //this.gambleText.position.set(360,170);
        //this.gambleText.scale.set(1.4, 1.4);
        //this.gambleText.visible = false;

        //this.gameIntro = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.GAME_INTRO));
        //this.gameIntro.position.set(360,360);
        //this.gameIntro.visible = false;
        //this.gameIntro.name = "GameIntroLol";
        //this.gameIntroTimeline = gsap.timeline();

        this.slayerSpine = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.FS_SLAYER));
        this.slayerSpine.position.set(360,386);
        this.slayerSpine.visible = false;

        this.introSpine = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.FS_INTRO));
        this.introSpine.position.set(360,360);

        this.noWinSpine = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.NO_WIN_SPINE));
        this.noWinSpine.position.set(360,386);
        this.noWinSpine.visible = false;

        this.maxWinSpine = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.MAX_WIN_SPINE));
        this.maxWinSpine.position.set(360,386);
        this.maxWinSpine.visible = false;

        this.outroInformation = new FreespinsOutroInformation();

        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this.gambleYesButton = new ContinueButton(BrickSnake2000.apiPlugin.translations.translate("YES"));
        this.gambleYesButton.setSize(240, 120);
        this.yesButtonCallback = this.doubleOrNothingYes;
        this.gambleYesButton.addClickCallback(() => this.yesButtonCallback());
        this.gambleYesButton.position.set(210, 560);
        this.gambleYesButton.pivot.set(this.gambleYesButton.width * 0.5, this.gambleYesButton.height * 0.5);
        this.gambleYesButton.enable(false);
        this.gambleYesButton.alpha = 0;

        this.gambleNoButton = new ContinueButton(BrickSnake2000.apiPlugin.translations.translate("NO"));
        this.gambleNoButton.setSize(240, 120);
        this.noButtonCallback = this.doubleOrNothingNo;
        this.gambleNoButton.addClickCallback(() => this.noButtonCallback());
        this.gambleNoButton.position.set(510, 560);
        this.gambleNoButton.pivot.set(this.gambleNoButton.width * 0.5, this.gambleNoButton.height * 0.5);
        this.gambleNoButton.enable(false);
        this.gambleNoButton.alpha = 0;

        this.replayClick = new TimelineSprite(BrickSnake2000.assetLoader.getTextures(BrickSnake2000GameAssets.REPLAY_CLICK));
        this.replayClick.blendMode = PIXI.BLEND_MODES.ADD;
        this.replayClick.scale.set(2,2);
        this.replayClick.anchor.set(0.5, 0.5);
        this.replayClick.position.set(360, 560);
        this.replayClick.hide();

        this.addChild(this.fsIntroBackground);
        this.addChild(this.sfsIntroBackground);
        this.addChild(this.maxWinBackground);
        this.addChild(this.maxWinDoubleBackground);
        this.addChild(this.maxWinNothingBackground);
        this.addChild(this.slayerSpine);
        this.addChild(this.introSpine);
        this.addChild(this.outroInformation);
        this.addChild(this.noWinSpine);
        this.addChild(this.maxWinSpine);
        this.addChild(this.button);
        this.addChild(this.gambleWarningText)
        this.addChild(this.gambleConfirmationText)
        //this.addChild(this.gambleText)
        this.addChild(this.gambleYesButton);
        this.addChild(this.gambleNoButton);
        this.addChild(this.replayClick);
        this.alpha = 0;
        this.onResize();
    }

    onResize():void {
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        } else {
            this.button.position.set(360, NolimitApplication.screenBounds.bottom - 250);
        }
        this.fsIntroBackground.width = NolimitApplication.screenBounds.width;
        this.fsIntroBackground.height = NolimitApplication.screenBounds.height;
        this.sfsIntroBackground.width = NolimitApplication.screenBounds.width;
        this.sfsIntroBackground.height = NolimitApplication.screenBounds.height;
        this.maxWinBackground.width = NolimitApplication.screenBounds.width;
        this.maxWinBackground.height = NolimitApplication.screenBounds.height;
        this.maxWinDoubleBackground.width = NolimitApplication.screenBounds.width;
        this.maxWinDoubleBackground.height = NolimitApplication.screenBounds.height;
        this.maxWinNothingBackground.width = NolimitApplication.screenBounds.width;
        this.maxWinNothingBackground.height = NolimitApplication.screenBounds.height;
    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.CONTINUE_BUTTON);
        gsap.to(this.button, {duration:0.2, alpha:0});
        delete this.clickCallback;
    }

    private doubleOrNothingYes() {
        this.gambleYesButton.enable(false);
        this.gambleNoButton.enable(false);
        this.gambleWarningText.visible = false;
        this.gambleConfirmationText.visible = false;
        //this.gambleText.visible = false;
        BrickSnake2000.apiPlugin.betHandler.pickAndClickBet(1, false);
        BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.DOUBLE_OR_NOTHING_YES);
        gsap.timeline()
            .add(gsap.to(this.gambleYesButton, {duration:0.2, alpha:0}))
            .add(gsap.to(this.gambleNoButton, {duration:0.2, alpha:0}), '<');
    }

    private doubleOrNothingNo() {
        this.gambleYesButton.enable(false);
        this.gambleNoButton.enable(false);
        this.gambleWarningText.visible = false;
        this.gambleWarningText.visible = false;
        //this.gambleText.visible = false;
        BrickSnake2000.apiPlugin.betHandler.pickAndClickBet(0, false);
        BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.DOUBLE_OR_NOTHING_YES);
        gsap.timeline()
            .add(gsap.to(this.gambleYesButton, {duration:0.2, alpha:0}))
            .add(gsap.to(this.gambleNoButton, {duration:0.2, alpha:0}), '<');
    }

    public noWin(version:string):gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.introSpine.visible = false;
                this.noWinSpine.visible = true;
                this.noWinSpine.state.setAnimation(0, `No_Win_${version}`, true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.1}))
            .add(() => {}, '>1.5')
            .add(gsap.to(this, {alpha: 0, duration: 0.1}))
            .add(() =>  {
                this.noWinSpine.state.setEmptyAnimation(0, 0);
                this.noWinSpine.visible = false;
                this.introSpine.visible = true;
            });
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration:0.2, alpha:1}));
        return tl;
    }

    public enableDoubleOrNothing(instant:boolean = false):gsap.core.Timeline {
        const noButtonAlpha = BrickSnake2000.model.isGodModeDeluxe ? 0 : 1;
        return gsap.timeline()
            .add(() => {
                this.yesButtonCallback = noButtonAlpha == 0
                                         ? this.doubleOrNothingYes
                                         : this.enableDoubleOrNothingWarning;
                this.noButtonCallback = this.doubleOrNothingNo;
                this.gambleWarningText.visible = true;
                this.gambleConfirmationText.visible = false;
                //this.gambleText.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win_Window", true);
                this.gambleYesButton.enable(true);
                if (noButtonAlpha == 1)
                    this.gambleNoButton.enable(true);
            })
            .add(gsap.to(this.gambleYesButton, {duration: instant ? 0 : 0.2, alpha:1}))
            .add(gsap.to(this.gambleNoButton, {duration: instant ? 0 : 0.2, alpha:noButtonAlpha}), '<');
    }

    public enableDoubleOrNothingWarning() {
        this.yesButtonCallback = this.doubleOrNothingYes;
        this.noButtonCallback = () => {
            BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.DOUBLE_OR_NOTHING_YES);
            this.enableDoubleOrNothing(true);
        }
        this.gambleWarningText.visible = false;
        this.gambleConfirmationText.visible = true;
        BrickSnake2000.soundPlayer.playSound(BrickSnake2000Sound.DOUBLE_OR_NOTHING_YES);
    }

    public replayDoubleOrNothing(option:number):gsap.core.Timeline {
        const noButtonAlpha = BrickSnake2000.model.isGodModeDeluxe ? 0 : 1;
        return gsap.timeline()
            .add(() => {
                this.gambleWarningText.visible = true;
                //this.gambleText.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win_Window", true);
                this.gambleYesButton.enable(false);
                if (noButtonAlpha == 1)
                    this.gambleNoButton.enable(false);
            })
            .add(gsap.to(this.gambleYesButton, {duration:0.2, alpha:1}))
            .add(gsap.to(this.gambleNoButton, {duration:0.2, alpha:noButtonAlpha}), '<')
            .add(() => {}, '>1')
            .add(() => {
                this.replayClick.position.x = option == 0 ? 510 : 210;
                this.replayClick.show();
                this.replayClick.playLoop();
            })
            .add(() => {
                this.replayClick.hide();
                this.replayClick.stopLoop();
                this.replayClick.setFrame(0);
                BrickSnake2000.apiPlugin.betHandler.pickAndClickBet(option, false);
                this.gambleWarningText.visible = false;
            }, `>${this.replayClick.totalDuration}`)
            .add(gsap.to(this.gambleYesButton, {duration:0.2, alpha:0}), '<')
            .add(gsap.to(this.gambleNoButton, {duration:0.2, alpha:0}), '<')
    }

    private showIntroOutroThing(background:PIXI.Sprite, introSpineClip:string):gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                background.visible = true;
                this.introSpine.state.setAnimation(0, introSpineClip, true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    private hideIntroOutroThing(background:PIXI.Sprite):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: 0.5}))
            .add(() =>  {
                background.visible = false;
                this.introSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showIntro():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                //this.fsIntroBackground.visible = true;
                this.introSpine.state.setAnimation(0, "FS_Intro", true);
            })
            .add(() => {this.alpha = 1});
    }

    public hideIntro():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {this.alpha = 0})
            .add(() =>  {
                this.introSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showIntroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                //this.fsIntroBackground.visible = true;
                this.introSpine.state.setAnimation(0, "SFS_Intro", true);
            })
            .add(() => {this.alpha = 1});
    }

    public hideIntroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {this.alpha = 0})
            .add(() =>  {
                this.introSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showUpgrade():gsap.core.Timeline {
        return this.showIntroOutroThing(this.sfsIntroBackground, "FS_Upgrade");
    }

    public hideUpgrade():gsap.core.Timeline {
        return this.hideIntroOutroThing(this.sfsIntroBackground);
    }

    public showMaxWin():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.maxWinBackground.visible = true;
                this.introSpine.visible = false;
                this.maxWinSpine.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win", true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    public showMaxWinDouble():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.maxWinBackground.visible = false;
                this.maxWinDoubleBackground.visible = true;
                this.introSpine.visible = false;
                this.maxWinSpine.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win_Double", true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    public showMaxWinZero():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.maxWinBackground.visible = false;
                this.maxWinNothingBackground.visible = true;
                this.introSpine.visible = false;
                this.maxWinSpine.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win_Nothing", true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    public hideMaxWin():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: 0.5}))
            .add(() =>  {
                this.maxWinBackground.visible = false;
                this.maxWinDoubleBackground.visible = false;
                this.maxWinNothingBackground.visible = false;
                this.introSpine.visible = true;
                this.maxWinSpine.visible = false;
                this.maxWinSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showOutro():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.showIntroOutroThing(this.fsIntroBackground, "FS_Outro"))
            .add(this.outroInformation.showOutroInformation());
    }

    public hideOutro():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.hideIntroOutroThing(this.fsIntroBackground))
            .add(this.outroInformation.hideOutroInformation());
    }

    public showOutroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.showIntroOutroThing(this.sfsIntroBackground, "SFS_Outro"))
            .add(this.outroInformation.showOutroInformation());
    }

    public hideOutroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.hideIntroOutroThing(this.sfsIntroBackground))
            .add(this.outroInformation.hideOutroInformation());
    }

    public showSlayer():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.introSpine.visible = false;
                this.slayerSpine.visible = true;
                this.slayerSpine.state.setAnimation(0, "Slayer", true);
            })
            //.add(gsap.to(this, {alpha: 1, duration: 0.1}))
            .add(() => {
                this.alpha = 1;
            })
            .add(() => {}, '>2')
            .add(() => {
                this.alpha = 0;
            })
            //.add(gsap.to(this, {alpha: 0, duration: 0.1}))
            .add(() =>  {
                this.slayerSpine.state.setEmptyAnimation(0, 0);
                this.introSpine.visible = true;
                this.slayerSpine.visible = false;
            });
    }


    //public showGameIntro(): gsap.core.Timeline {
    //    this.gameIntroTimeline =  gsap.timeline()
    //        .add(() => {
    //            this.gameIntro.visible = true;
    //            this.gameIntro.state.setAnimation(0, `Intro_${Math.floor(Math.random() * 4) + 1}`, true)
    //        })
    //        .add(gsap.to(this, {alpha: 1, duration:0.1}), '<')
    //        .add(gsap.to(this, {alpha: 0, duration:0.1}), '>4.3')
    //        .add(() => {
    //            this.gameIntro.visible = false;
    //            this.gameIntro.state.setEmptyAnimation(0,0);
    //        })
    //        .addLabel("end");
    //    return this.gameIntroTimeline;
    //}

    //public killGameIntro(): gsap.core.Timeline {
    //    return this.gameIntroTimeline.seek("end", false);
    //}
}